import { UPLOADTYPE } from "../models/enums/globalEnums";
import { getStorageItemLocal } from "./storageServices";

export type AdminEntry = {
  id: number;
  category: string;

  subCategory: string;
  state: string;
  categoryName: string;
  stateName: string;
  description: string;
  description2: string;
  description3: string;
  imageUrls: string | string[];
  videoUrls: string | string[];
  thumbnail: string | string[];
  lastUpdated: string;
  pdfUrls: string | string[];
  pdfIsActive: boolean;
  pdfName: string;
  pdfUrls2: string | string[];
  pdfIsActive2: boolean;
  pdfName2: string;
  pdfUrls3: string | string[];
  pdfIsActive3: boolean;
  pdfName3: string;
  grid1: string | string[];
  gridThumbnail1: string | string[];
  gridType1: string;
  gridIconName1: string;
  grid2: string | string[];
  gridThumbnail2: string | string[];
  gridIconName2: string;
  gridType2: string;
  grid3: string | string[];
  gridThumbnail3: string | string[];
  gridType3: string;
  gridIconName3: string;
  grid4: string | string[];
  gridThumbnail4: string | string[];
  gridType4: string;
  gridIconName4: string;
  grid5: string | string[];
  gridThumbnail5: string | string[];
  gridType5: string;
  gridIconName5: string;
  grid6: string | string[];
  gridThumbnail6: string | string[];
  gridType6: string;
  gridIconName6: string;
  grid7: string | string[];
  gridThumbnail7: string | string[];
  gridType7: string;
  gridIconName7: string;
  grid8: string | string[];
  gridThumbnail8: string | string[];
  gridType8: string;
  gridIconName8: string;
  grid9: string | string[];
  gridThumbnail9: string | string[];
  gridType9: string;
  gridIconName9: string;
  isActive: boolean;
  uploadBy: string;
  approveBy: string;
  status: string;
  statusCode: string;
  publishBy: string;
};

export const defaultAdminEntry: AdminEntry = {
  id: 0,
  category: "",
  categoryName: "",
  state: "",

  stateName: "",
  subCategory: "",
  description: "",
  description2: "",
  description3: "",
  imageUrls: [],
  videoUrls: [],
  thumbnail: [],
  lastUpdated: new Date().toISOString(),
  pdfUrls: [],
  pdfIsActive: false,
  pdfName: "",
  pdfUrls2: [],
  pdfIsActive2: false,
  pdfName2: "",
  pdfUrls3: [],
  pdfIsActive3: false,
  pdfName3: "",
  grid1: [],
  gridThumbnail1: [],
  gridType1: "",
  gridIconName1: "",
  grid2: [],
  gridThumbnail2: [],
  gridType2: "",
  gridIconName2: "",
  grid3: [],
  gridThumbnail3: [],
  gridType3: "",
  gridIconName3: "",
  grid4: [],
  gridThumbnail4: [],
  gridType4: "",
  gridIconName4: "",
  grid5: [],
  gridThumbnail5: [],
  gridType5: "",
  gridIconName5: "",
  grid6: [],
  gridThumbnail6: [],
  gridType6: "",
  gridIconName6: "",
  grid7: [],
  gridThumbnail7: [],
  gridType7: "",
  gridIconName7: "",
  grid8: [],
  gridThumbnail8: [],
  gridType8: "",
  gridIconName8: "",
  grid9: [],
  gridThumbnail9: [],
  gridType9: "",
  gridIconName9: "",
  isActive: true,
  uploadBy: "",
  approveBy: "",
  status: "",
  statusCode: "",
  publishBy: "",
};

export const clearDefaultAdminEntry = (
  ID: number,
  category: string,
  state: string
): AdminEntry => ({
  id: ID,
  category: category,

  state: state,
  categoryName: "",
  stateName: "",
  subCategory: "",
  description: "",
  description2: "",
  description3: "",
  imageUrls: [],
  videoUrls: [],
  thumbnail: [],
  lastUpdated: new Date().toISOString(),
  pdfUrls: [],
  pdfIsActive: false,
  pdfName: "",
  pdfUrls2: [],
  pdfIsActive2: false,
  pdfName2: "",
  pdfUrls3: [],
  pdfIsActive3: false,
  pdfName3: "",
  grid1: [],
  gridThumbnail1: [],
  gridType1: "",
  gridIconName1: "",
  grid2: [],
  gridThumbnail2: [],
  gridType2: "",
  gridIconName2: "",
  grid3: [],
  gridThumbnail3: [],
  gridType3: "",
  gridIconName3: "",
  grid4: [],
  gridThumbnail4: [],
  gridType4: "",
  gridIconName4: "",
  grid5: [],
  gridThumbnail5: [],
  gridType5: "",
  gridIconName5: "",
  grid6: [],
  gridThumbnail6: [],
  gridType6: "",
  gridIconName6: "",
  grid7: [],
  gridThumbnail7: [],
  gridType7: "",
  gridIconName7: "",
  grid8: [],
  gridThumbnail8: [],
  gridType8: "",
  gridIconName8: "",
  grid9: [],
  gridThumbnail9: [],
  gridType9: "",
  gridIconName9: "",
  isActive: true,
  uploadBy: "",
  approveBy: "",
  status: "",
  statusCode: "",
  publishBy: "",
});

export const ensureArray = (value: any): string[] => {
  if (typeof value === "string") {
    return value
      .split(",")
      .map((v) => v.trim())
      .filter(Boolean);
  } else if (Array.isArray(value)) {
    return value;
  }
  return [];
};

export const prepareAdminEntryForEdit = (entry: any): AdminEntry => ({
  ...entry,
  imageUrls: ensureArray(entry.imageUrls),
  videoUrls: ensureArray(entry.videoUrls),
  thumbnail: ensureArray(entry.thumbnail),

  pdfUrls: ensureArray(entry.pdfUrls),
  pdfUrls2: ensureArray(entry.pdfUrls2),
  pdfUrls3: ensureArray(entry.pdfUrls3),

  grid1: ensureArray(entry.grid1),
  gridThumbnail1: ensureArray(entry.gridThumbnail1),
  grid2: ensureArray(entry.grid2),
  gridThumbnail2: ensureArray(entry.gridThumbnail2),
  grid3: ensureArray(entry.grid3),
  gridThumbnail3: ensureArray(entry.gridThumbnail3),
  grid4: ensureArray(entry.grid4),
  gridThumbnail4: ensureArray(entry.gridThumbnail4),
  grid5: ensureArray(entry.grid5),
  gridThumbnail5: ensureArray(entry.gridThumbnail5),
  grid6: ensureArray(entry.grid6),
  gridThumbnail6: ensureArray(entry.gridThumbnail6),
  grid7: ensureArray(entry.grid7),
  gridThumbnail7: ensureArray(entry.gridThumbnail7),
  grid8: ensureArray(entry.grid8),
  gridThumbnail8: ensureArray(entry.gridThumbnail8),
  grid9: ensureArray(entry.grid9),
  gridThumbnail9: ensureArray(entry.gridThumbnail9),
});

/// handle Save start
// export const buildAdminEntryFormData = async (
//   formData: AdminEntry,
//   selectedImages: File[],
//   selectedVideos: File[],
//   selectedThumbnail: File[],
//   editingIndex: number | null,
//   selectedPdf: File[],
//   selectedPdf2: File[],
//   selectedPdf3: File[],

//   ispdfChecked: boolean,
//   ispdfChecked2: boolean,
//   ispdfChecked3: boolean,
//   isChecked: boolean
// ): Promise<FormData> => {
//   const formDataToSend = new FormData();

//   formDataToSend.append("id", editingIndex?.toString() ?? "0");
//   formDataToSend.append("category", formData.category);
//   formDataToSend.append("subcategory", formData.subCategory);
//   formDataToSend.append("description", formData.description);
//   formDataToSend.append("description2", formData.description2);
//   formDataToSend.append("description3", formData.description3);
//   formDataToSend.append("status", "Pending for Approval");
//   formDataToSend.append("pdfIsActive", ispdfChecked.toString());
//   formDataToSend.append("pdfIsActive2", ispdfChecked2.toString());
//   formDataToSend.append("pdfIsActive3", ispdfChecked3.toString());
//   formDataToSend.append("isActive", isChecked.toString());

//   formDataToSend.append("pdfName", formData.pdfName);
//   formDataToSend.append("pdfName2", formData.pdfName2);
//   formDataToSend.append("pdfName3", formData.pdfName3);

//   selectedImages.forEach((image) => {
//     formDataToSend.append("imageUrls", image);
//   });

//   if (selectedThumbnail?.length) {
//     selectedThumbnail.forEach((thumb) => {
//       formDataToSend.append("thumbnail", thumb);
//     });
//   }

//   selectedVideos.forEach((video) => {
//     formDataToSend.append("videoUrls", video);
//   });

//   if (Array.isArray(formData.imageUrls)) {
//     for (const url of formData.imageUrls) {
//       const response = await fetch(url);
//       const blob = await response.blob();
//       const fileName = url.split("/").pop() || "default.jpg";
//       const file = new File([blob], fileName, { type: blob.type });
//       formDataToSend.append("imageUrls", file);
//     }
//   }

//   if (
//     (!selectedVideos || selectedVideos.length === 0) &&
//     Array.isArray(formData.videoUrls) &&
//     formData.videoUrls.length > 0
//   ) {
//     for (const url of formData.videoUrls) {
//       const response = await fetch(url);
//       const blob = await response.blob();
//       const fileName = url.split("/").pop() || "video.mp4";
//       const file = new File([blob], fileName, { type: blob.type });
//       formDataToSend.append("videoUrls", file);
//     }
//   }

//   //------------------Save-------------------------pdfUrls2
//   selectedPdf.forEach((pdf) => {
//     formDataToSend.append("pdfUrls", pdf);
//   });

//   if (Array.isArray(formData.pdfUrls)) {
//     for (const url of formData.pdfUrls) {
//       const response = await fetch(url);
//       const blob = await response.blob();
//       const fileName = url.split("/").pop() || "default.pdf";
//       const file = new File([blob], fileName, { type: blob.type });
//       formDataToSend.append("pdfUrls", file);
//     }
//   }

//   // ++++++++++++++++++++++++++++++++++++++++++2

//   selectedPdf2.forEach((pdf) => {
//     formDataToSend.append("pdfUrls2", pdf);
//   });

//   if (Array.isArray(formData.pdfUrls2)) {
//     for (const url of formData.pdfUrls2) {
//       const response = await fetch(url);
//       const blob = await response.blob();
//       const fileName = url.split("/").pop() || "default.pdf";
//       const file = new File([blob], fileName, { type: blob.type });
//       formDataToSend.append("pdfUrls2", file);
//     }
//   }

//   // ++++++++++++++++++++++++++++++++++++++++++3

//   selectedPdf3.forEach((pdf) => {
//     formDataToSend.append("pdfUrls3", pdf);
//   });

//   if (Array.isArray(formData.pdfUrls3)) {
//     for (const url of formData.pdfUrls3) {
//       const response = await fetch(url);
//       const blob = await response.blob();
//       const fileName = url.split("/").pop() || "default.pdf";
//       const file = new File([blob], fileName, { type: blob.type });
//       formDataToSend.append("pdfUrls3", file);
//     }
//   }

//   return formDataToSend;
// };

export const buildAdminEntryFormData = async (
  formData: AdminEntry,
  selectedImages: File[],
  selectedVideos: File[],
  selectedThumbnail: File[],
  editingIndex: number | null,
  selectedPdf: File[],
  selectedPdf2: File[],
  selectedPdf3: File[],
  ispdfChecked: boolean,
  ispdfChecked2: boolean,
  ispdfChecked3: boolean,
  isChecked: boolean,
  grid1: File[],
  grid2: File[],
  grid3: File[],
  grid4: File[],
  grid5: File[],
  grid6: File[],
  grid7: File[],
  grid8: File[],
  grid9: File[],

  gridThumbnail1: File[],
  gridThumbnail2: File[],
  gridThumbnail3: File[],
  gridThumbnail4: File[],
  gridThumbnail5: File[],
  gridThumbnail6: File[],
  gridThumbnail7: File[],
  gridThumbnail8: File[],
  gridThumbnail9: File[]
): Promise<FormData> => {
  const formDataToSend = new FormData();

  const appendFiles = (files: File[], key: string) => {
    files.forEach((file) => formDataToSend.append(key, file));
  };

  const appendSingleFileFromUrl = async (url: string, key: string) => {
    const response = await fetch(url);
    const blob = await response.blob();
    const fileName = url.split("/").pop() || "default.file";
    const file = new File([blob], fileName, { type: blob.type });
    formDataToSend.append(key, file);
  };

  const appendBlobFilesFromUrls = async (
    urls: string[] | string,
    key: string
  ) => {
    if (!urls) return;
    const list = Array.isArray(urls)
      ? urls
      : urls
          .split(",")
          .map((v) => v.trim())
          .filter(Boolean);
    for (const url of list) {
      await appendSingleFileFromUrl(url, key);
    }
  };

  // Basic data
  formDataToSend.append("id", editingIndex?.toString() ?? "0");
  formDataToSend.append("category", formData.category);
  formDataToSend.append("state", formData.state);
  formDataToSend.append("subcategory", formData.subCategory);
  formDataToSend.append("description", formData.description);
  formDataToSend.append("description2", formData.description2);
  formDataToSend.append("description3", formData.description3);
  formDataToSend.append("status", "Approved"); //Approved  Pending for Approval
  formDataToSend.append("pdfIsActive", ispdfChecked.toString());
  formDataToSend.append("pdfIsActive2", ispdfChecked2.toString());
  formDataToSend.append("pdfIsActive3", ispdfChecked3.toString());
  formDataToSend.append("isActive", isChecked.toString());
  formDataToSend.append("pdfName", formData.pdfName);
  formDataToSend.append("pdfName2", formData.pdfName2);
  formDataToSend.append("pdfName3", formData.pdfName3);

  formDataToSend.append("gridType1", formData.gridType1);
  formDataToSend.append("gridType2", formData.gridType2);
  formDataToSend.append("gridType3", formData.gridType3);
  formDataToSend.append("gridType4", formData.gridType4);
  formDataToSend.append("gridType5", formData.gridType5);
  formDataToSend.append("gridType6", formData.gridType6);
  formDataToSend.append("gridType7", formData.gridType7);
  formDataToSend.append("gridType8", formData.gridType8);
  formDataToSend.append("gridType9", formData.gridType9);
  formDataToSend.append("gridIconName1", formData.gridIconName1);
  formDataToSend.append("gridIconName2", formData.gridIconName2);
  formDataToSend.append("gridIconName3", formData.gridIconName3);
  formDataToSend.append("gridIconName4", formData.gridIconName4);
  formDataToSend.append("gridIconName5", formData.gridIconName5);
  formDataToSend.append("gridIconName6", formData.gridIconName6);
  formDataToSend.append("gridIconName7", formData.gridIconName7);
  formDataToSend.append("gridIconName8", formData.gridIconName8);
  formDataToSend.append("gridIconName9", formData.gridIconName9);

  const username = getStorageItemLocal("username") ?? "";
  formDataToSend.append("uploadBy", username);

  // Images: both selected and existing
  appendFiles(selectedImages, "imageUrls"); // prev image uploaded
  await appendBlobFilesFromUrls(formData.imageUrls, "imageUrls"); // new Image

  // Thumbnail: use new or existing one
  if (selectedThumbnail.length > 0) {
    appendFiles(selectedThumbnail, "thumbnail");
  } else if (formData.thumbnail) {
    await appendBlobFilesFromUrls(formData.thumbnail, "thumbnail");
  }

  // Videos: new or fallback to existing
  if (selectedVideos.length > 0) {
    appendFiles(selectedVideos, "videoUrls");
  } else {
    await appendBlobFilesFromUrls(formData.videoUrls, "videoUrls");
  }

  // PDFs: new or fallback to existing
  // if (selectedPdf.length > 0) {
  //   appendFiles(selectedPdf, "pdfUrls");
  // } else {
  //   await appendBlobFilesFromUrls(formData.pdfUrls, "pdfUrls");
  // }

  // if (selectedPdf2.length > 0) {
  //   appendFiles(selectedPdf2, "pdfUrls2");
  // } else {
  //   await appendBlobFilesFromUrls(formData.pdfUrls2, "pdfUrls2");
  // }

  // if (selectedPdf3.length > 0) {
  //   appendFiles(selectedPdf3, "pdfUrls3");
  // } else {
  //   await appendBlobFilesFromUrls(formData.pdfUrls3, "pdfUrls3");
  // }

  // if (selectedPdf.length > 0) {
  //   appendFiles(selectedPdf, "pdfUrls");
  // } else {
  //   await appendBlobFilesFromUrls(formData.pdfUrls, "pdfUrls");
  // }
  /// grid thumbnail
  if (gridThumbnail1.length > 0) {
    appendFiles(gridThumbnail1, "gridThumbnail1");
  } else {
    await appendBlobFilesFromUrls(formData.gridThumbnail1, "gridThumbnail1");
  }
  if (gridThumbnail2.length > 0) {
    appendFiles(gridThumbnail2, "gridThumbnail2");
  } else {
    await appendBlobFilesFromUrls(formData.gridThumbnail2, "gridThumbnail2");
  }

  if (gridThumbnail3.length > 0) {
    appendFiles(gridThumbnail3, "gridThumbnail3");
  } else {
    await appendBlobFilesFromUrls(formData.gridThumbnail3, "gridThumbnail3");
  }

  if (gridThumbnail4.length > 0) {
    appendFiles(gridThumbnail4, "gridThumbnail4");
  } else {
    await appendBlobFilesFromUrls(formData.gridThumbnail4, "gridThumbnail4");
  }

  if (gridThumbnail5.length > 0) {
    appendFiles(gridThumbnail5, "gridThumbnail5");
  } else {
    await appendBlobFilesFromUrls(formData.gridThumbnail5, "gridThumbnail5");
  }

  if (gridThumbnail6.length > 0) {
    appendFiles(gridThumbnail6, "gridThumbnail6");
  } else {
    await appendBlobFilesFromUrls(formData.gridThumbnail6, "gridThumbnail6");
  }

  if (gridThumbnail7.length > 0) {
    appendFiles(gridThumbnail7, "gridThumbnail7");
  } else {
    await appendBlobFilesFromUrls(formData.gridThumbnail7, "gridThumbnail7");
  }

  if (gridThumbnail8.length > 0) {
    appendFiles(gridThumbnail8, "gridThumbnail8");
  } else {
    await appendBlobFilesFromUrls(formData.gridThumbnail8, "gridThumbnail8");
  }

  if (gridThumbnail9.length > 0) {
    appendFiles(gridThumbnail9, "gridThumbnail9");
  } else {
    await appendBlobFilesFromUrls(formData.gridThumbnail9, "gridThumbnail9");
  }

  ///// grid media /////////////////////////////////

  // if (grid1.length > 0) {
  appendFiles(grid1, "grid1");
  // }
  if (formData.gridType1 === UPLOADTYPE.IMAGES || grid1.length === 0) {
    await appendBlobFilesFromUrls(formData.grid1, "grid1");
  }

  // if (grid2.length > 0) {
  appendFiles(grid2, "grid2");
  // }
  if (formData.gridType2 === UPLOADTYPE.IMAGES || grid2.length === 0) {
    await appendBlobFilesFromUrls(formData.grid2, "grid2");
  }

  // if (grid3.length > 0) {
  appendFiles(grid3, "grid3");
  // }
  if (formData.gridType3 === UPLOADTYPE.IMAGES || grid3.length === 0) {
    await appendBlobFilesFromUrls(formData.grid3, "grid3");
  }

  // if (grid4.length > 0) {
  appendFiles(grid4, "grid4");
  // }
  if (formData.gridType4 === UPLOADTYPE.IMAGES || grid4.length === 0) {
    await appendBlobFilesFromUrls(formData.grid4, "grid4");
  }

  // if (grid5.length > 0) {
  appendFiles(grid5, "grid5");
  // }
  if (formData.gridType5 === UPLOADTYPE.IMAGES || grid5.length === 0) {
    await appendBlobFilesFromUrls(formData.grid5, "grid5");
  }

  // if (grid6.length > 0) {
  appendFiles(grid6, "grid6");
  // }
  if (formData.gridType6 === UPLOADTYPE.IMAGES || grid6.length === 0) {
    await appendBlobFilesFromUrls(formData.grid6, "grid6");
  }

  // if (grid7.length > 0) {
  appendFiles(grid7, "grid7");
  // }
  if (formData.gridType7 === UPLOADTYPE.IMAGES || grid7.length === 0) {
    await appendBlobFilesFromUrls(formData.grid7, "grid7");
  }

  // if (grid8.length > 0) {
  appendFiles(grid8, "grid8");
  // }
  if (formData.gridType8 === UPLOADTYPE.IMAGES || grid8.length === 0) {
    await appendBlobFilesFromUrls(formData.grid8, "grid8");
  }

  // if (grid9.length > 0) {
  appendFiles(grid9, "grid9");
  // }
  if (formData.gridType9 === UPLOADTYPE.IMAGES || grid9.length === 0) {
    await appendBlobFilesFromUrls(formData.grid9, "grid9");
  }

  return formDataToSend;
};

export const saveAdminEntry = async (
  formData: AdminEntry,
  selectedImages: File[],
  selectedVideos: File[],
  selectedThumbnail: File[],
  editingIndex: number | null,
  apiBaseUrl: string,

  selectedPdf: File[],
  selectedPdf2: File[],
  selectedPdf3: File[],

  ispdfChecked: boolean,
  ispdfChecked2: boolean,
  ispdfChecked3: boolean,
  isChecked: boolean,
  grid1: File[],
  grid2: File[],
  grid3: File[],
  grid4: File[],
  grid5: File[],
  grid6: File[],
  grid7: File[],
  grid8: File[],
  grid9: File[],

  gridThumbnail1: File[],
  gridThumbnail2: File[],
  gridThumbnail3: File[],
  gridThumbnail4: File[],
  gridThumbnail5: File[],
  gridThumbnail6: File[],
  gridThumbnail7: File[],
  gridThumbnail8: File[],
  gridThumbnail9: File[]
): Promise<Response> => {
  const formDataToSend = await buildAdminEntryFormData(
    formData,
    selectedImages,
    selectedVideos,
    selectedThumbnail,
    editingIndex,
    selectedPdf,
    selectedPdf2,
    selectedPdf3,
    ispdfChecked,
    ispdfChecked2,
    ispdfChecked3,
    isChecked,
    grid1,
    grid2,
    grid3,
    grid4,
    grid5,
    grid6,
    grid7,
    grid8,
    grid9,
    gridThumbnail1,
    gridThumbnail2,
    gridThumbnail3,
    gridThumbnail4,
    gridThumbnail5,
    gridThumbnail6,
    gridThumbnail7,
    gridThumbnail8,
    gridThumbnail9
  );

  const url =
    editingIndex !== null
      ? `${apiBaseUrl}/${formData.id}`
      : `${apiBaseUrl}/upload`;

  return fetch(url, {
    method: editingIndex !== null ? "PUT" : "POST",
    body: formDataToSend,
  });
};

/// handle Save end

// export const removeImageByIndex = (
//   imageArray: string[] | string,
//   indexToRemove: number
// ): string[] => {
//   const images = Array.isArray(imageArray)
//     ? imageArray
//     : imageArray
//         .split(",")
//         .map((img) => img.trim())
//         .filter(Boolean);

//   //   return images.filter((_, index) => index !== indexToRemove);

//   const updated = images.filter((_, index) => index !== indexToRemove);

//   return updated.length === 0 ? [] : updated;
// };

export const removeImageByIndex = (
  imageArray: string[] | string,
  indexToRemove: number
): string[] => {
  // Handle case where imageArray is a single string without commas
  if (typeof imageArray === "string") {
    if (!imageArray.includes(",")) {
      return indexToRemove === 0 ? [] : [imageArray];
    }

    const images = imageArray
      .split(",")
      .map((img) => img.trim())
      .filter(Boolean);

    return images.filter((_, index) => index !== indexToRemove);
  }

  // Handle case where imageArray is already an array
  return imageArray.filter((_, index) => index !== indexToRemove);
};

export const removeVideoByIndex = (
  videoArray: string[] | string,
  indexToRemove: number
): string[] => {
  if (typeof videoArray === "string") {
    if (!videoArray.includes(",")) {
      return indexToRemove === 0 ? [] : [videoArray];
    }

    const videos = videoArray
      .split(",")
      .map((v) => v.trim())
      .filter(Boolean);

    return videos.filter((_, index) => index !== indexToRemove);
  }

  // videoArray is already an array
  return videoArray.filter((_, index) => index !== indexToRemove);
};
